import classNames from 'classnames';
import { type FC, type HTMLAttributes } from 'react';

import styles from './divider.module.scss';

export interface DividerProps {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  flexItem?: boolean;
  'aria-hidden'?: boolean | 'true' | 'false';
}

export const Divider: FC<DividerProps & Omit<HTMLAttributes<HTMLHRElement | HTMLSpanElement>, 'children'>> = ({
  className,
  orientation = 'horizontal',
  flexItem = false,
  'aria-hidden': ariaHidden,
  ...rest
}) => {
  const cls = classNames(styles.divider, className);
  const dataProps = {
    'data-orientation': orientation,
    'data-flex-item': flexItem || undefined,
  };

  if (orientation === 'vertical') {
    return (
      <span
        className={cls}
        role="separator"
        aria-orientation="vertical"
        aria-hidden={ariaHidden}
        {...dataProps}
        {...(rest as HTMLAttributes<HTMLSpanElement>)}
      />
    );
  }

  return <hr className={cls} aria-hidden={ariaHidden} {...dataProps} {...(rest as HTMLAttributes<HTMLHRElement>)} />;
};
